import { QContentProvider } from '@exam-management/common/qcontent-provider';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  QContentDetailFormProvider,
  QContentDetailsModalProvider,
} from '@exam-management/qcontent-detail';
import { useParams } from '@exam-management/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function QContentDetailLayout() {
  const { contentId, structureId } = useParams(
    '/qbank-structures/:structureId/qcontents/single/:contentId',
  );

  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.QBANK.QUESTION.VIEW}>
      <QContentProvider contentId={contentId} structureId={structureId}>
        <QContentDetailFormProvider>
          <QContentDetailsModalProvider>
            <Outlet />
          </QContentDetailsModalProvider>
        </QContentDetailFormProvider>
      </QContentProvider>
    </PermissionGuard>
  );
}
